import React, { useRef } from "react";
import { OverviewListLayout } from "@Local/Components/OverviewList";
import { AutocompleteField, Grid, MenuItem, SelectField, TextField } from '@curves/ui-base';

import { isEmpty, refIsRequiredError } from "@Util/utils";
const CyclePurchaseOverviewSearchBar = props => {
	const { getOverviewData, sourceData, options } = props;
	const { clubID, shippingDay, cycleOrderType, productName, memberSearch, cycleOrderNo } = sourceData || {};
	const { shippingDayOptions = [], cycleOrderTypeOptions = [], clubOptions = [] } = options || {};
	const clubRef = useRef(null);
	const shippingDayRef = useRef(null);
	const cycleOrderTypeRef = useRef(null);
	const memberSearchRef = useRef(null);
	const productNameRef = useRef(null);
	const cycleOrderNoRef = useRef(null);
	const getParamsData = () => {
		return {
			clubID: clubRef.current?.getResult("value"),
			shippingDay: shippingDayRef.current?.getResult("value"),
			cycleOrderType: cycleOrderTypeRef.current?.getResult("value"),
			productName: productNameRef.current?.getResult("value"),
			memberSearch: memberSearchRef.current?.getResult("value"),
			cycleOrderNo: cycleOrderNoRef.current?.getResult("value"),
		};
	};
	const handleSubmit = e => {
		if (refIsRequiredError(clubRef, shippingDayRef, cycleOrderTypeRef, memberSearchRef, productNameRef, cycleOrderNoRef)) return;
		const paramsData = getParamsData();
		getOverviewData(paramsData);
	};
	return (
		<OverviewListLayout.SearchBar isShowActions onSubmit={handleSubmit}>
			<Grid spacing={2} container>
				<Grid xs={4} item>
					<AutocompleteField
						key={`${clubID}_${clubOptions.length}`}
						label={"店鋪名稱"}
						inputProps={{ placeholder: "請輸入店名/店碼" }}
						ref={clubRef}
						options={clubOptions}
						optionKeys={["text"]}
						primaryKey={"value"}
						direction="column"
						defaultValue={clubID}
						required
						fullWidth
					/>
				</Grid>
				<Grid xs={4} item>
					{!isEmpty(shippingDayOptions) && (
						<SelectField key={shippingDay} label={"出貨週期"} ref={shippingDayRef} defaultValue={shippingDay} fullWidth>
							{shippingDayOptions.map(({ value, text, disabled }) => (
								<MenuItem key={value} value={value} disabled={disabled}>
									{text}
								</MenuItem>
							))}
						</SelectField>
					)}
				</Grid>
				<Grid xs={4} item>
					{!isEmpty(cycleOrderTypeOptions) && (
						<SelectField key={cycleOrderType} label={"訂單狀態"} ref={cycleOrderTypeRef} defaultValue={cycleOrderType} fullWidth>
							{cycleOrderTypeOptions.map(({ value, text, disabled }) => (
								<MenuItem key={value} value={value} disabled={disabled}>
									{text}
								</MenuItem>
							))}
						</SelectField>
					)}
				</Grid>
			</Grid>
			<Grid spacing={2} className="mt-2" container>
				<Grid xs={4} item>
					<TextField label={"會員"} fullWidth placeholder={"請輸入會員姓名/會員編號/手機"} ref={memberSearchRef} defaultValue={memberSearch} />
				</Grid>
				<Grid xs={4} item>
					<TextField label={"商品名稱"} fullWidth placeholder={"請輸入商品名稱"} ref={productNameRef} defaultValue={productName} />
				</Grid>
                <Grid xs={4} item>
					<TextField label={"循環訂單編號"} fullWidth placeholder={"請輸入循環訂單編號"} ref={cycleOrderNoRef} defaultValue={cycleOrderNo} />
				</Grid>
			</Grid>
		</OverviewListLayout.SearchBar>
	);
};
export default CyclePurchaseOverviewSearchBar;
